import axios from "axios";
import { z } from "zod";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import { DateSchema } from "../../Types";
import ValidationError from "../../ZodError";
export const LinkToken = z.object({
    expiration: DateSchema,
    token: z.string(),
});
export const Response = LinkToken;
export const url = (host, androidPackageName) => {
    let urlParameters = "";
    const linkEnvQs = host === "localhost" ? "local" : host === "uat-stagingapp" ? "staging" : "";
    if (environment() === "PROD") {
        // always ignore the hostType parameter in PROD.
        if (androidPackageName !== undefined) {
            urlParameters = `?androidPackageName=${androidPackageName}`;
        }
    }
    else {
        // always handle the hostType parameter in non PROD environments.
        if (host !== null && androidPackageName !== undefined) {
            urlParameters = `?linkEnv=${linkEnvQs}&androidPackageName=${androidPackageName}`;
        }
        else if (host !== null) {
            urlParameters = `?linkEnv=${linkEnvQs}`;
        }
        else if (androidPackageName !== undefined) {
            urlParameters = `?androidPackageName=${androidPackageName}`;
        }
    }
    return environment() === "PROD"
        ? `https://middleware.prod.farther.com/external-account/v1/plaid-links/link-token${urlParameters}`
        : `https://middleware.uat.farther.com/external-account/v1/plaid-links/link-token${urlParameters}`;
};
const getPlaidLinkToken = async (host, config, androidPackageName) => {
    const { data } = await axios.get(url(host, androidPackageName), {
        headers: {
            Client: config.clientId,
            Authorization: `Bearer ${config.jwt}`,
        },
    });
    const decoded = Response.safeParse(data);
    if (decoded.success) {
        return decoded.data;
    }
    else {
        const errorMessage = `[${getPlaidLinkToken.name}] Could not parse`;
        errorLog(errorMessage, decoded.error.message);
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
};
export default getPlaidLinkToken;
//# sourceMappingURL=getPlaidLinkToken.js.map